import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { showLoading, toast } from "view/component/Alert.js";
import TablePelayanan from "./TablePelayanan";
import API from "apiService";
const VerifLab = () => {
  const [state, setstate] = useState({
    datas: [],
    wa: [],
    filteredDatas: [],
    isLoading: true,
    clinic: [],
    frDate: JSON.parse(localStorage.getItem("SearchDate"))
      ? JSON.parse(localStorage.getItem("SearchDate")).date.frDate
      : moment(new Date()).format("YYYY-MM-DD"),
    enDate: JSON.parse(localStorage.getItem("SearchDate"))
      ? JSON.parse(localStorage.getItem("SearchDate")).date.enDate
      : moment(new Date()).format("YYYY-MM-DD"),
    keyword: {
      name: "",
      bod: "",
      nik: "",
      noRm: "",
      visitId: "",
      clinicId: 6,
      continueId: "",
    },
    tahun: 2023,
    parent: false,
    limit: "10",
    sort: "ASC",
    served: false,
    puskesmas_id: JSON.parse(localStorage.getItem("puskesmasProfile"))
      ? JSON.parse(localStorage.getItem("puskesmasProfile")).code
      : "",
  });

  const onChangeKeyword = (e) => {
    const param = e.target.value;
    setstate({
      tahun: param,
    });
  };

  const CheckHandler = (checked) => {
    if (checked) {
      setstate(
        {
          ...state,
          served: true,
        },
        () => fetchDatas()
      );
    } else {
      setstate(
        {
          ...state,
          served: false,
        },
        () => fetchDatas()
      );
    }
  };
  const HandleChange = (event) => {
    let id = event.target.value;
    let parent = state.clinic.some((e) => e.clinic_id === id);
    if (parent) {
      setstate({
        ...state,
        keyword: {
          ...state.keyword,
          clinicId: id, // update the value of specific key
        },
      });
      setstate({
        ...state,
        parent: true,
      });
    } else {
      setstate({
        ...state,
        keyword: {
          ...state.keyword,
          clinicId: id, // update the value of specific key
        },
      });
      setstate({
        ...state,
        parent: false,
      });
    }
  };

  const FetchDatas = async () => {
    let param = {
      tahun: state.tahun,
    };
    showLoading("Mencari Data");

    const res = await API.post("/registration/odha", param);
    if (res.status === "success.") {
      toast({ status: "success", text: "Data Ditemukan" });
      setstate({
        ...state,
        datas: res.data,
        wa: res.wa,
        isLoading: false,
      });
      localStorage.setItem(
        "SearchDate",
        JSON.stringify({
          date: { frDate: state.frDate, enDate: state.enDate },
          clinic: state.keyword.clinicId,
        })
      );
    } else {
      toast({ status: "error", text: "Data tidak ditemukan" });
      setstate({
        ...state,
        datas: [],
        isLoading: false,
      });
    }
  };
  const frDate = moment(state.frDate).toDate();
  const enDate = moment(state.enDate).toDate();
  const { filteredDatas, isLoading } = state;
  console.log(state);
  return (
    <div>
      <div className="container-fluid my-3">
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header border-0">
                <div className="row">
                  <div className="col-md-2">
                    <h3>Tahun</h3>
                  </div>

                  <input
                    className="form-control col-md-5"
                    name="katakunci"
                    placeholder="Tahun"
                    value={state.tahun}
                    type="text"
                    onChange={(e) => onChangeKeyword(e)}
                  />
                  <button
                    style={{ marginLeft: "2%" }}
                    className="btn btn-success"
                    onClick={() => FetchDatas()}
                  >
                    CARI DATA
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="card">
              <TablePelayanan
                headers={[
                  "No",
                  "Nama",
                  "RM",
                  "Nik",
                  "Januari",
                  "Februari",
                  "Maret",
                  "April",
                  "Mei",
                  "Juni",
                  "Juli",
                  "Agustus",
                  "September",
                  "Oktober",
                  "November",
                  "Desember",

                  //   "Aksi",
                ]}
                datas={state.datas}
                isLoading={isLoading}
                listsPerPage={10}
                // history={this.props.history}
                keyword={{
                  keyword: state.keyword,
                  frDate: state.frDate,
                  enDate: state.enDate,
                  limit: state.limit,
                  sort: state.sort,
                  served: state.served,
                }}
                wa={state.wa}
                fetchDatas={() => FetchDatas()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifLab;
